// Import the functions you need from the SDKs you need
import {initializeApp,} from "firebase/app";
// https://firebase.google.com/docs/web/setup#available-libraries
import {getFirestore} from 'firebase/firestore';
import {getAuth} from "firebase/auth";
import {getStorage} from "firebase/storage";
import {getMessaging} from "firebase/messaging";

// const firebaseConfig = {
// 	apiKey: "AIzaSyAhSh2rOy9jkXaH1MOQkFIZTymgJWPzpxo",
// 	authDomain: "lendco-7e823.firebaseapp.com",
// 	projectId: "lendco-7e823",
// 	storageBucket: "lendco-7e823.appspot.com",
// 	messagingSenderId: "715240184218",
// 	appId: "1:715240184218:web:191d20d02db62efb628223",
// 	measurementId: "G-F4P49K4X5S"
// };


//mphdev firebase account
const firebaseConfig = {
	apiKey: "AIzaSyCgg_vEfVmhPRc79_E62UAuxKJLJbQLcWo",
	authDomain: "lendco-66697.firebaseapp.com",
	projectId: "lendco-66697",
	storageBucket: "lendco-66697.firebasestorage.app",
	messagingSenderId: "1008711931418",
	appId: "1:1008711931418:web:33c32228fa1ef29b2423a3",
	measurementId: "G-6L92FJVB2M"
};


// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const firestore = getFirestore(firebaseApp);
const auth = getAuth(firebaseApp);
const firebaseStorage = getStorage(firebaseApp);
const firebaseMessaging = getMessaging(firebaseApp);


export {firebaseApp, firestore, auth, firebaseStorage, firebaseMessaging}

